import type { gsap as GsapInstance } from 'gsap';
import type { ScrollTrigger as ScrollTriggerInstance } from 'gsap/ScrollTrigger';

type GsapBundle = {
  gsap: typeof GsapInstance;
  ScrollTrigger: typeof ScrollTriggerInstance;
};

let pending: Promise<GsapBundle> | null = null;

/**
 * GSAP and ScrollTrigger together are ~112kB. Loading them on demand keeps them
 * off the first-paint path; every caller shares one in-flight promise.
 */
export function loadGsap(): Promise<GsapBundle> {
  if (!pending) {
    pending = Promise.all([import('gsap'), import('gsap/ScrollTrigger')]).then(
      ([gsapModule, scrollTriggerModule]) => {
        const { ScrollTrigger } = scrollTriggerModule;
        gsapModule.gsap.registerPlugin(ScrollTrigger);
        return { gsap: gsapModule.gsap, ScrollTrigger };
      },
    );
  }

  return pending;
}
